import { ReactNode } from "react";

/**
 * Small pieces the catalog pages (prefixes, file names, custom fields, asset
 * types, tablet users) share in their add/edit panel. The settings kit has no
 * form fields yet, so they live here.
 */

export const FIELD_INPUT_CLASS =
  "block min-h-11 w-full rounded-lg border border-gray-300 bg-white px-2.5 py-2 text-base text-gray-900 md:min-h-[38px] md:text-sm placeholder:text-gray-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500";

type FieldProps = {
  /** The `id` of the input inside, so a click on the label focuses it. */
  htmlFor: string;
  label: string;
  /** One line under the input saying what to type. */
  hint?: ReactNode;
  children: ReactNode;
};

export function Field({ htmlFor, label, hint, children }: FieldProps) {
  return (
    <div>
      <label
        htmlFor={htmlFor}
        className="mb-1 block text-sm font-medium text-gray-700"
      >
        {label}
      </label>
      {children}
      {hint && <div className="mt-1 text-xs text-gray-600">{hint}</div>}
    </div>
  );
}

/** The panel opens above the table, not under the row, so it names the row it is for. */
export function PanelHeading({ children }: { children: ReactNode }) {
  return (
    <h4 className="mb-3 text-sm font-semibold text-gray-900">{children}</h4>
  );
}

/** The "add" button in the card header. */
export function AddButton({
  label,
  onClick,
}: {
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex min-h-11 items-center md:min-h-9 [@media(pointer:coarse)]:min-h-11 rounded-lg border border-indigo-600 bg-indigo-600 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
    >
      {label}
    </button>
  );
}
